import { render, staticRenderFns } from "./EmployeeWorkSchedules.vue?vue&type=template&id=04d87f49&"
import script from "./EmployeeWorkSchedules.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports